<!--
Feedback confirmation screen
@author cm359n
-->
<template>
  <div id="contain" class="container">
  <Nav name="Feedback" :back="false" />
  <div>
    <main class="p-2" id="feedbackmain">
      <p id="feedbackSubmitHdr">Do you like the new UofG Life app?</p>
      <p class="feedbackSubmitMsg">
        Your feedback will help us improve the app.
      </p>
      <form target="_blank" name="bookingForm">
         <div class="feedbackForm">
             <a v-for="(img, index) in starArray()" :key="'star-' + (index + 1)" class="dispStar" href="#" @click="setRating(index+1)" >
                 <img v-if="img.colour == 'clear'" :title="img.descr" :alt="img.descr" class="dispStar" src="@/assets/clearStar.png"/>
                 <img v-if="img.colour == 'yellow'" :title="img.descr" :alt="img.descr" class="dispStar" src="@/assets/yellowStar.png"/>
             </a>

            <p class="feedbackSubmitSubHdr">What can we improve?</p>
            <textarea name="feedback" :onchange="checkFeedback()" class="feedbackArea" v-model="feedback" />
            <div id='feedbackBtn'>
              <input :disabled="disableFeedback" type="button" value="Send Feedback" id="sendFeedback" @click="sendFeedback" class="feedbackButton"/>
            </div>

         </div>
      </form>
    </main>
    </div>
    <Footer active="index"/>
  </div>
</template>

<script>
import Footer from '@/components/FooterMenu.vue'

export default {
  name: 'SubmitFeedback',
  components: {
    Footer
  },
  data () {
    return {
      rating: 1,
      feedback: '',
      disableFeedback: true
    }
  },

  mounted () {

  },
  methods: {
    setRating (r) {
      this.rating = r
    },
    starArray () {
      // returns yellowStar (rating) times and clearStar (5-rating) times
      let ret = []
      for (let i = 0; i < 5; i++) {
        let ds = (i + 1) + ((i == 0) ? ' star' : ' stars')
        let col = (i < this.rating) ? 'yellow' : 'clear'
        let arr = {
          'colour': col,
          'descr': ds
        }
        ret.push(arr)
      }
      return ret
    },
    checkFeedback () {
      this.disableFeedback = (this.feedback == '')
    },
    sendFeedback () {
      // TODO post feedback...
      // ... and then ...
      this.$router.push('/feedback/confirmation')
    }
  }
}
</script>
<style>
input.searchButton:disabled {
  background: #9512726b;
}

input.feedbackButton {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  height: 55px;
  width: 338px;

  background: #951272;
  border-radius: 50px;
}

.feedbackSubmitMsg {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
    text-align: center;
    color: var(--uog-dark-blue);
}

.feedbackArea {

    left: 24px;
    top: 370px;
    width: 327px;
    height: 142px;

    background: #F9F9FD;
    border: 1px solid #DADADA;
    box-sizing: border-box;
    border-radius: 6px;
}

div.feedbackForm {
    text-align: center;
}

.dispStar {
  width: 28px;
  height: 28px;

}

#feedbackBtn {
  margin-top:44px;
}

#feedbackBtn input:disabled {
  opacity: 0.5;
}

main.p-2#feedbackmain {
    text-align: center;
}

img#feedbackEndImg {
    margin-top: 62px;
}

.feedbackSubmitSubHdr {
    margin-top: 43px;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    text-align: center;
    color: var(--uog-dark-blue);
}

</style>
